export const SET_ITEMS = 'app/formationTypes/set/items';
export const SET_INITIALIZED = 'app/formationTypes/set/initialized';
export const SET_ERROR = 'app/formationTypes/set/error';
